export const FOCUS_TRAP_SELECTOR = '[role="dialog"][aria-modal="true"][data-hm-modal="true"]';
//# sourceMappingURL=constants.js.map